import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "./BreadCrumb.css";

export default function BreadCrumb() {
  return (
    <div className="breadCrumb_main">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="breadcrumb_title">
              <Breadcrumb>
                <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/products">Shop</Breadcrumb.Item>
                <Breadcrumb.Item active>Cushions & Pillows</Breadcrumb.Item>
              </Breadcrumb>
              <h1>Cushions & Pillows</h1>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="breadcrumb_desc">
              <p>
                Introducing our collection of pillows and cushions, designed to
                add comfort and style to any room in your home. Inspired by the
                latest design trends and made with the highest quality
                materials, our pillows and cushions are the perfect finishing
                touch to any décor.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
